import { businesses } from "./data/index";

export default function SearchGrid() {
  return (
    <div className="container mx-auto px-4 py-10 md:py-20">
      <h1 className="text-3xl font-semibold text-center text-emerald-600 mb-8">
        Search on Our Myanwen
      </h1>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {businesses.map((business) => (
          <a
            key={business.id}
            target="__blank"
            href={business.link}
            className="border-none shadow-sm cursor-pointer block"
          >
            <div className="p-4">
              <div className="flex flex-col items-center space-y-2">
                <div className="relative w-24 h-24 ">
                  <img
                    src={business.logo}
                    alt={`${business.name} logo`}
                    fill
                    className="object-contain"
                  />
                </div>
                <p className="text-sm text-center text-gray-600">
                  {business.name}
                </p>
              </div>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
}
